var _rect, _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSplashMobile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 70,
    viewBox: "0 0 320 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 70,
    fill: "url(#paint0_linear_1112_927)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M220 56.5C270.5 45.3603 307 43.3333 320 43.5V70H170C189.5 64 208.667 59 220 56.5Z",
    fill: "url(#paint1_linear_1112_927)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1112_927",
    x1: 160,
    y1: 0,
    x2: 160,
    y2: 70,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#182D5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A3161"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1112_927",
    x1: 245,
    y1: 43.4908,
    x2: 245,
    y2: 70,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A5AB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B5AB2"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSplashMobile);
export default __webpack_public_path__ + "static/media/splash-mobile.8519ff30ecbeb0a2e4107314e5e7fc70.svg";
export { ForwardRef as ReactComponent };